import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { missing360DataBannerCyclesMessageAtom } from '@/atoms/dataLocker/general';
import { InfoBar } from '@/components/feedback/InfoBar';

export const ThreeSixtyMissingDataInfoBar = ({ translationKey }: { translationKey: string }) => {
  const { t } = useTranslation('dataLocker');
  const missing360DataBannerCyclesMessage = useAtomValue(missing360DataBannerCyclesMessageAtom);

  return (
    missing360DataBannerCyclesMessage && (
      <div className="m-4">
        <InfoBar
          testId="data-locker-360-missing-data-info-bar"
          mainText={t(translationKey)}
          additionalText={missing360DataBannerCyclesMessage}
        />
      </div>
    )
  );
};
